import { use } from 'react';
import { ThemeContext } from './ThemeContext';

/**
 * `true` when the active template is sleek. Unlike `useTemplate`, it does not
 * require a ThemeProvider: shared screens (reveal, notifications) are also
 * mounted without one — tests, previews — and there they keep the default
 * look, so a missing provider simply means "not sleek".
 */
export function useIsSleek(): boolean {
  return use(ThemeContext)?.template === 'sleek';
}
